(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kaiivo-faq-split')) {
    customElements.define('kaiivo-faq-split', class extends HTMLElement {
      connectedCallback() {
        if (this.selectBlock) return;
        this.selectBlock = (event) => {
          if (!(event.target instanceof Element) || !this.contains(event.target)) return;
          const details = event.target.closest('details');
          if (details && this.contains(details)) details.open = true;
        };
        document.addEventListener('shopify:block:select', this.selectBlock);
      }
      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.selectBlock);
        this.selectBlock = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaiivo-home-catalog"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kaiivo-catalog')) {
  customElements.define('kaiivo-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.querySelector('[data-filters]').hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-need], [data-reset]');
        if (!button || !this.contains(button)) return;
        const need = button.hasAttribute('data-reset') || button.getAttribute('aria-pressed') === 'true' ? '' : button.dataset.need;
        this.filter(need, button.querySelector('strong')?.textContent || '');
      }, { signal });
      this.addEventListener('shopify:block:select', () => this.filter('', ''), { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
    filter(need, label) {
      this.querySelectorAll('[data-need]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.need === need)));
      let count = 0;
      this.querySelectorAll('[data-product-need]').forEach(card => { card.hidden = Boolean(need && card.dataset.productNeed !== need); if (!card.hidden) count++; });
      this.querySelectorAll('[data-group]').forEach(group => { group.hidden = !Array.from(group.querySelectorAll('[data-product-need]')).some(card => !card.hidden); });
      const status = this.querySelector('[data-status]');
      status.textContent = need ? `${label} · ${count}` : status.dataset.default;
      this.querySelector('[data-reset]').hidden = !need;
      this.querySelector('[data-empty]').hidden = count !== 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaiivo-home-chews"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('kaiivo-needs')) {
  customElements.define('kaiivo-needs', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.querySelector('[data-filters]').hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-need], [data-reset]');
        if (!button || !this.contains(button)) return;
        const need = button.hasAttribute('data-reset') || button.getAttribute('aria-pressed') === 'true' ? '' : button.dataset.need;
        document.dispatchEvent(new CustomEvent('kaiivo:filter', { detail: { need, label: need ? button.querySelector('strong').textContent : '' } }));
      }, { signal });
      document.addEventListener('kaiivo:filter', event => {
        this.querySelectorAll('[data-need]').forEach(button => button.setAttribute('aria-pressed', String(Boolean(event.detail.need) && button.dataset.need === event.detail.need)));
        this.querySelector('[data-reset]').hidden = !event.detail.need;
        const status = this.querySelector('[data-status]');
        status.textContent = event.detail.need ? event.detail.label : status.dataset.default;
      }, { signal });
      this.addEventListener('shopify:block:select', () => this.reset(), { signal });
      this.reset();
    }
    reset() { document.dispatchEvent(new CustomEvent('kaiivo:filter', { detail: { need: '', label: '' } })); }
    disconnectedCallback() { this.controller?.abort(); this.reset(); }
  });
}
if (!customElements.get('kaiivo-product-group')) {
  customElements.define('kaiivo-product-group', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      document.addEventListener('kaiivo:filter', event => this.filter(event.detail.need), { signal });
      this.addEventListener('shopify:block:select', () => {
        document.dispatchEvent(new CustomEvent('kaiivo:filter', { detail: { need: '', label: '' } }));
      }, { signal });
      this.filter(document.querySelector('kaiivo-needs [data-need][aria-pressed="true"]')?.dataset.need || '');
    }
    disconnectedCallback() { this.controller?.abort(); }
    filter(need) {
      let count = 0;
      this.querySelectorAll('[data-product-need]').forEach(card => {
        card.hidden = Boolean(need && card.dataset.productNeed !== need);
        if (!card.hidden) count++;
      });
      this.hidden = Boolean(need && count === 0);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaiivo-home-liquids"] && !Shopify.designMode) return;
  try {
    


if (!customElements.get('kaiivo-needs')) {
  customElements.define('kaiivo-needs', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.querySelector('[data-filters]').hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-need], [data-reset]');
        if (!button || !this.contains(button)) return;
        const need = button.hasAttribute('data-reset') || button.getAttribute('aria-pressed') === 'true' ? '' : button.dataset.need;
        document.dispatchEvent(new CustomEvent('kaiivo:filter', { detail: { need, label: need ? button.querySelector('strong').textContent : '' } }));
      }, { signal });
      document.addEventListener('kaiivo:filter', event => {
        this.querySelectorAll('[data-need]').forEach(button => button.setAttribute('aria-pressed', String(Boolean(event.detail.need) && button.dataset.need === event.detail.need)));
        this.querySelector('[data-reset]').hidden = !event.detail.need;
        const status = this.querySelector('[data-status]');
        status.textContent = event.detail.need ? event.detail.label : status.dataset.default;
      }, { signal });
      this.addEventListener('shopify:block:select', () => this.reset(), { signal });
      this.reset();
    }
    reset() { document.dispatchEvent(new CustomEvent('kaiivo:filter', { detail: { need: '', label: '' } })); }
    disconnectedCallback() { this.controller?.abort(); this.reset(); }
  });
}
if (!customElements.get('kaiivo-product-group')) {
  customElements.define('kaiivo-product-group', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      document.addEventListener('kaiivo:filter', event => this.filter(event.detail.need), { signal });
      this.addEventListener('shopify:block:select', () => {
        document.dispatchEvent(new CustomEvent('kaiivo:filter', { detail: { need: '', label: '' } }));
      }, { signal });
      this.filter(document.querySelector('kaiivo-needs [data-need][aria-pressed="true"]')?.dataset.need || '');
    }
    disconnectedCallback() { this.controller?.abort(); }
    filter(need) {
      let count = 0;
      this.querySelectorAll('[data-product-need]').forEach(card => {
        card.hidden = Boolean(need && card.dataset.productNeed !== need);
        if (!card.hidden) count++;
      });
      this.hidden = Boolean(need && count === 0);
    }
  });
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaiivo-home-needs"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('kaiivo-needs')) {
  customElements.define('kaiivo-needs', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.querySelector('[data-filters]').hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-need], [data-reset]');
        if (!button || !this.contains(button)) return;
        const need = button.hasAttribute('data-reset') || button.getAttribute('aria-pressed') === 'true' ? '' : button.dataset.need;
        document.dispatchEvent(new CustomEvent('kaiivo:filter', { detail: { need, label: need ? button.querySelector('strong').textContent : '' } }));
      }, { signal });
      document.addEventListener('kaiivo:filter', event => {
        this.querySelectorAll('[data-need]').forEach(button => button.setAttribute('aria-pressed', String(Boolean(event.detail.need) && button.dataset.need === event.detail.need)));
        this.querySelector('[data-reset]').hidden = !event.detail.need;
        const status = this.querySelector('[data-status]');
        status.textContent = event.detail.need ? event.detail.label : status.dataset.default;
      }, { signal });
      this.addEventListener('shopify:block:select', () => this.reset(), { signal });
      this.reset();
    }
    reset() { document.dispatchEvent(new CustomEvent('kaiivo:filter', { detail: { need: '', label: '' } })); }
    disconnectedCallback() { this.controller?.abort(); this.reset(); }
  });
}
if (!customElements.get('kaiivo-product-group')) {
  customElements.define('kaiivo-product-group', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      document.addEventListener('kaiivo:filter', event => this.filter(event.detail.need), { signal });
      this.addEventListener('shopify:block:select', () => {
        document.dispatchEvent(new CustomEvent('kaiivo:filter', { detail: { need: '', label: '' } }));
      }, { signal });
      this.filter(document.querySelector('kaiivo-needs [data-need][aria-pressed="true"]')?.dataset.need || '');
    }
    disconnectedCallback() { this.controller?.abort(); }
    filter(need) {
      let count = 0;
      this.querySelectorAll('[data-product-need]').forEach(card => {
        card.hidden = Boolean(need && card.dataset.productNeed !== need);
        if (!card.hidden) count++;
      });
      this.hidden = Boolean(need && count === 0);
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
